/**
 * Sends the availability form to the NEXT Real Estate Team LeadConnector form
 * (https://api.leadconnectorhq.com/widget/form/mXCV65OaDPGRBhpqQpg3).
 *
 * Full name and email map to LeadConnector's built-in contact fields.
 * "MLS or city" and "MLS software" are custom fields, identified by their
 * unique keys. Each value is sent under every key variant LeadConnector
 * may expect ("contact.mls_or_city" and "mls_or_city").
 */
export const leadConnectorConfig = {
  formId: 'mXCV65OaDPGRBhpqQpg3',
  locationId: '828452PqbqvwQtCcsK76',
  fieldKeys: {
    market: 'contact.mls_or_city',
    mlsSoftware: 'contact.mls_software',
  },
}

const SUBMIT_URL = 'https://backend.leadconnectorhq.com/forms/submit'

export type AvailabilitySubmission = {
  name: string
  email: string
  market: string
  mlsSoftware: string
}

export async function submitAvailability(values: AvailabilitySubmission): Promise<void> {
  const { formId, locationId, fieldKeys } = leadConnectorConfig

  const formData: Record<string, unknown> = {
    full_name: values.name,
    email: values.email,
    ...keyVariants(fieldKeys.market, values.market),
    ...keyVariants(fieldKeys.mlsSoftware, values.mlsSoftware),
    formId,
    location_id: locationId,
    eventData: {
      source: 'direct',
      type: 'page-visit',
      domain: window.location.hostname,
      page: { url: window.location.href, title: document.title },
      timestamp: Date.now(),
    },
    sessionId: createSessionId(),
  }

  const body = new FormData()
  body.append('formData', JSON.stringify(formData))
  body.append('locationId', locationId)
  body.append('formId', formId)

  const response = await fetch(SUBMIT_URL, { method: 'POST', body })
  if (!response.ok) {
    throw new Error(`LeadConnector submission failed (${response.status})`)
  }
}

function keyVariants(key: string, value: string): Record<string, string> {
  const shortKey = key.replace(/^contact\./, '')
  return { [key]: value, [shortKey]: value }
}

function createSessionId() {
  if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) return crypto.randomUUID()
  return `${Date.now()}-${Math.random().toString(36).slice(2)}`
}
